import { hasPermits } from 'directives'
// import './details.scss'

const directives = {
  hasPermits
}

export default {
  name: 'location-administration-tabs',
  directives,
  data () {
    return {
      locId: this.$route.params.id
    }
  },
}
